import React from 'react';

const formatValue = ({
  newValue,
  currencyDisplay,
}: {
  prevValue: string;
  newValue: string;
  currencyDisplay: string;
}): string => {
  if (newValue === '') {
    return newValue;
  }

  // eslint-disable-next-line no-useless-escape
  const valueWithDots = newValue.replace(/[^\d\.]/g, '');
  const [digitsBeforeDot, ...digitsAfterDot] = valueWithDots.split('.');
  const parts = digitsBeforeDot ? [digitsBeforeDot] : [];

  if (digitsAfterDot.length) {
    if (!parts.length) {
      parts.push('0');
    }
    const digitsAfterDotString = digitsAfterDot.join('');
    parts.push(digitsAfterDotString);
  }
  return `${currencyDisplay}${parts.map((p, index) => (p && !index ? Number(p).toLocaleString() : p)).join('.')}`;
};

export const useMonthlyIncomeMask = (props: {
  currencyDisplay: string;
}): { value: string | undefined; onChange: (newValue: string) => void } => {
  const { currencyDisplay } = props;
  const [value, setValue] = React.useState<string | undefined>(undefined);

  return {
    value,
    onChange: (newValue: string) => {
      setValue((prevValue) =>
        formatValue({ prevValue: prevValue ?? '', newValue, currencyDisplay }),
      );
    },
  };
};

export const useLoanAmountMask = (props: {
  currencyDisplay: string;
}): {
  valueLoanAmount: string | undefined;
  onChangeLoanAmount: (newValue: string) => void;
} => {
  const { currencyDisplay } = props;
  const [value, setValue] = React.useState<string | undefined>(undefined);
  return {
    valueLoanAmount: value,
    onChangeLoanAmount: (newValue: string) => {
      setValue((prevValue) =>
        formatValue({ prevValue: prevValue ?? '', newValue, currencyDisplay }),
      );
    },
  };
};
